import * as React from 'react'
import styled, { css } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { ConversationMessageType, TenorGif } from '../../types'
import Icon, { IconTypes } from '../Icons/Icon'

const Container = styled.div`
  position: relative;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(245, 245, 245);
  border-radius: 12px;
  box-shadow: rgba(9, 14, 21, 0.16) 0px 0px 4px 0px;
  width: fit-content;
  overflow: hidden;
  z-index: 2147483001;
  margin: 0px 30px;
  padding: 6px;
  min-width: 150px;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`

const Items = styled.div`
  display: flex;
  flex-direction: column;
`

const Item = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  cursor: pointer;

  &:hover {
    background-color: #f8f8f7;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  i {
    font-size: 16px;
  }

  ${props => props.active && css`
    color: #e35712;
  
    svg {
      fill: currentColor;
    }
  `}

  span {
    flex: 1;
  }
`

interface IProps {
  activeMessageType: ConversationMessageType
  onMessageTypeSelect: (messageType: ConversationMessageType) => void
}

const MessageTypePopover = (props: IProps) => {
  const { t } = useTranslation()
  const { activeMessageType, onMessageTypeSelect } = props

  const messageTypes: { icon: IconTypes, type: ConversationMessageType }[] = [
    { icon: 'messenger-conversations-active', type: ConversationMessageType.TEXT },
    { icon: 'pencil', type: ConversationMessageType.NOTE }
  ]

  return (
    <Container>
      <Wrapper>
        <Items>
          {messageTypes.map((messageType, index) => {
            const active = messageType.type === activeMessageType
            return (
              <Item active={active} key={messageType.type} onClick={() => onMessageTypeSelect(messageType.type)}>
                <Icon icon={messageType.icon} />
                <span>{t(`ConversationMessageType::${messageType.type}`)}</span>
                <div>{active && <Icon icon='check' />}</div>
              </Item>
            )
          })}
        </Items>
      </Wrapper>
    </Container>
  )
}

export default MessageTypePopover